import { Button, Stack } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import BackButton from "./BackButton";


interface IProps {
  backlabel?: string;
  submitlabel?:string;
  disabled?: boolean;
  hideBack?: boolean;
  backPath?: string;
  marginTop?: number;
  justifyContent?: "flex-end" | "flex-start";
}

const SubmitButtonGroup = ({ backlabel, submitlabel, disabled, hideBack, backPath, marginTop, justifyContent }: IProps) => {

    const submit = submitlabel ? submitlabel: "Save Changes";

     return (
        <Stack justifyContent={justifyContent ?? "flex-end"} mt={marginTop ?? 3} direction="row" spacing={2} >
            
            {(hideBack === undefined || (hideBack === false)) && (
                <BackButton 
                    backlabel={backlabel} 
                    backPath={backPath} 
                />
            )}
            
            <Button variant="contained" type="submit" disabled={disabled}>{submit}</Button>
            
        </Stack>
  );
};
export default SubmitButtonGroup;
